module.exports = __webpack_public_path__ + "static/media/background_music.783ec403.mp3";